export class Designation
{
    public DesignationId : number;
    public DesignationCode : string;
    public DesignationName : string;
    public GradeId : number;
    public LevelId : number;
    public DecisionId : number;
    public IsActive : boolean;
}